import React from "react";
import UpdatePaymentMethodModal from "./modals/UpdatePaymentMethodModal";
import SimpleConfirmationDialog from "../../../SimpleConfirmationDialog";
import { Grid } from "@mui/material";
import { modalTypes } from "../../../../views/booking-overview/BuyerBooking";

const BuyerActiveDialogs = ({account, bookingToEdit, handleCloseModals, showModal, handleBookingCancellation, handleMonthlyBookingCancellation, handleUpdatePaymentMethod}) => {

    const cancelBookingOpen = showModal.show && showModal.type === modalTypes.activeBookingCancel;
    const endBookingOpen = showModal.show && showModal.type === modalTypes.endMonthly;
    const updatePaymentOpen = showModal.show && showModal.type === modalTypes.updatePayment;

    return <Grid>
        <SimpleConfirmationDialog
        onClose={handleCloseModals}
        onConfirm={handleBookingCancellation}
        open={cancelBookingOpen}
        title={"Cancel Booking"}
        body={"Are you sure you want to cancel this booking?"}
      />
      <SimpleConfirmationDialog
        onClose={handleCloseModals}
        onConfirm={handleMonthlyBookingCancellation}
        open={endBookingOpen}
        title={"End Monthly Booking"}
        body={"Are you sure you want to end this monthly booking?"}
      />
      <UpdatePaymentMethodModal
        onClose={handleCloseModals}
        open={updatePaymentOpen}
        booking={bookingToEdit}
        account={account}
        onSuccess={handleUpdatePaymentMethod}
      />
    </Grid>
};

export default BuyerActiveDialogs;